import { useMemo, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { buildSidebarGroups } from '../../utils/menuUtils';

const ENV_NAME = process.env.REACT_APP_ENV_NAME || 'Formosa';

export default function Sidebar({ collapsed, onToggle }) {
  const { permissions } = useAuth();
  const location = useLocation();
  const groups = useMemo(() => buildSidebarGroups(permissions), [permissions]);
  const [expanded, setExpanded] = useState({});

  function isGroupOpen(groupId) {
    if (expanded[groupId] !== undefined) {
      return expanded[groupId];
    }
    const group = groups.find((g) => g.id === groupId);
    return group?.children.some((c) => location.pathname === c.path) ?? false;
  }

  function toggleGroup(groupId) {
    setExpanded((prev) => ({
      ...prev,
      [groupId]: !isGroupOpen(groupId),
    }));
  }

  return (
    <aside className={`admin-sidebar${collapsed ? ' collapsed' : ''}`}>
      <div className="admin-sidebar-head">
        {!collapsed && <div className="admin-brand">{ENV_NAME} 后台</div>}
        <button
          type="button"
          className="admin-sidebar-toggle"
          onClick={onToggle}
          aria-label="切換側欄"
        >
          ≡
        </button>
      </div>

      <nav className="admin-nav">
        <NavLink to="/" end className="admin-nav-home">
          {!collapsed && '首頁'}
          {collapsed && '●'}
        </NavLink>

        {groups.map((group) => {
          const open = isGroupOpen(group.id);
          return (
            <div key={group.id} className="admin-nav-group">
              <button
                type="button"
                className={`admin-nav-group-title${open ? ' open' : ''}`}
                onClick={() => toggleGroup(group.id)}
                title={group.title}
              >
                {!collapsed && (
                  <>
                    <span>{group.title}</span>
                    <span className="admin-nav-chevron">{open ? '▾' : '▸'}</span>
                  </>
                )}
                {collapsed && '…'}
              </button>
              {open && !collapsed && (
                <div className="admin-nav-children">
                  {group.children.map((child) => (
                    <NavLink key={child.id} to={child.path}>
                      {child.title}
                    </NavLink>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </nav>
    </aside>
  );
}
